export default (
  state,
  { payload: { boardId, boardTitleText, itemCountMismatch } }
) => ({
  ...state,
  boards: { ...state.boards, boardId, boardTitleText, itemCountMismatch }
});
